module.exports = __webpack_public_path__ + "img/helags.04b99e4e.jpg";